import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';
import { UnsettledDocumentsQuery, UnsettledDocumentsQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(UnsettledDocumentsQuery)
@Wrapper(UnsettledDocumentsQueryHandlerBase)
export class UnsettledDocumentsQueryHandler {
    public constructor(
        http: Http,
        rootContext: RootContext
    ) { }
}
